import { ultrahumanXDiscountCodes } from 'content/ultrahumanX';
import { CartPolicy } from './types';
import { pass } from './cartLineHelpers';

export const uhxRemovalDiscountPolicy: CartPolicy = (input, _cart, meta) => {
  if (
    !meta.store ||
    !meta.ultrahumanXAdded ||
    meta.removedLineId !== meta.ultrahumanXAdded.id
  ) {
    return pass(input);
  }

  meta.discountOptions.removingUhx = true;

  const codesToStrip = new Set<string>();
  const uhxCode = ultrahumanXDiscountCodes[meta.store]?.discountCode;
  if (uhxCode) codesToStrip.add(uhxCode);

  if (input.discountCodes === undefined || !codesToStrip.size) {
    return pass(input, 'removingUhx flagged');
  }

  return {
    input: {
      ...input,
      discountCodes: input.discountCodes.filter((c) => !codesToStrip.has(c)),
    },
    reasons: ['strip UHX bundle code on UHX removal'],
  };
};
